"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReverseTransactionError = exports.GetTransactionByExternalIdError = exports.PostTransactionError = exports.GetAccountBalanceError = exports.GetOrCreateAccountError = exports.AvenLedgerAccountUnit = exports.AvenLedgerExternalSource = exports.AvenLedgerDirection = exports.AvenLedgerAccountType = void 0;
/** @TranslateToPython @TranslateToRust */
var AvenLedgerAccountType;
(function (AvenLedgerAccountType) {
    AvenLedgerAccountType["asset"] = "asset";
    AvenLedgerAccountType["liability"] = "liability";
    AvenLedgerAccountType["equity"] = "equity";
    AvenLedgerAccountType["revenue"] = "revenue";
    AvenLedgerAccountType["expense"] = "expense";
})(AvenLedgerAccountType || (exports.AvenLedgerAccountType = AvenLedgerAccountType = {}));
/** @TranslateToPython @TranslateToRust */
var AvenLedgerDirection;
(function (AvenLedgerDirection) {
    AvenLedgerDirection["debit"] = "debit";
    AvenLedgerDirection["credit"] = "credit";
})(AvenLedgerDirection || (exports.AvenLedgerDirection = AvenLedgerDirection = {}));
/** @TranslateToPython */
var AvenLedgerExternalSource;
(function (AvenLedgerExternalSource) {
    AvenLedgerExternalSource["onChainTransfer"] = "on_chain_transfer";
    AvenLedgerExternalSource["liquidationIntent"] = "liquidation_intent";
    AvenLedgerExternalSource["bitGoTradeOrder"] = "bit_go_trade_order";
    AvenLedgerExternalSource["withdrawalRequest"] = "withdrawal_request";
    AvenLedgerExternalSource["withdrawalRequestFailure"] = "withdrawal_request_failure";
    AvenLedgerExternalSource["rewardDeposit"] = "reward_deposit";
    AvenLedgerExternalSource["cryptoReferralReward"] = "CryptoReferralReward";
})(AvenLedgerExternalSource || (exports.AvenLedgerExternalSource = AvenLedgerExternalSource = {}));
/** @TranslateToPython @TranslateToRust */
var AvenLedgerAccountUnit;
(function (AvenLedgerAccountUnit) {
    AvenLedgerAccountUnit["cents"] = "cents";
    AvenLedgerAccountUnit["rewardsPoints"] = "rewardsPoints";
    AvenLedgerAccountUnit["satoshis"] = "satoshis";
})(AvenLedgerAccountUnit || (exports.AvenLedgerAccountUnit = AvenLedgerAccountUnit = {}));
var GetOrCreateAccountError;
(function (GetOrCreateAccountError) {
    GetOrCreateAccountError["mismatchedUnits"] = "MISMATCHED_UNITS";
    GetOrCreateAccountError["mismatchedType"] = "MISMATCHED_TYPE";
    GetOrCreateAccountError["bookNotFound"] = "BOOK_NOT_FOUND";
    GetOrCreateAccountError["mismatchedBook"] = "MISMATCHED_BOOK";
})(GetOrCreateAccountError || (exports.GetOrCreateAccountError = GetOrCreateAccountError = {}));
var GetAccountBalanceError;
(function (GetAccountBalanceError) {
    GetAccountBalanceError["accountNotFound"] = "ACCOUNT_NOT_FOUND";
})(GetAccountBalanceError || (exports.GetAccountBalanceError = GetAccountBalanceError = {}));
/** @TranslateToRust */
var PostTransactionError;
(function (PostTransactionError) {
    PostTransactionError["noDebits"] = "NO_DEBITS";
    PostTransactionError["noCredits"] = "NO_CREDITS";
    PostTransactionError["debitsAndCreditsNotBalanced"] = "DEBITS_AND_CREDITS_NOT_BALANCED";
    PostTransactionError["invalidEntryAmount"] = "INVALID_ENTRY_AMOUNT";
    PostTransactionError["accountNotFound"] = "ACCOUNT_NOT_FOUND";
    PostTransactionError["entryAndAccountUnitsMismatch"] = "ENTRY_AND_ACCOUNT_UNITS_MISMATCH";
    PostTransactionError["idempotencyKeyAlreadyUsed"] = "IDEMPOTENCY_KEY_ALREADY_USED";
    PostTransactionError["accountBookMismatch"] = "ACCOUNT_BOOK_MISMATCH";
    PostTransactionError["bookNotFound"] = "BOOK_NOT_FOUND";
    PostTransactionError["externalIdAndSourceAlreadyUsedInBook"] = "EXTERNAL_ID_AND_SOURCE_ALREADY_USED_IN_BOOK";
})(PostTransactionError || (exports.PostTransactionError = PostTransactionError = {}));
var GetTransactionByExternalIdError;
(function (GetTransactionByExternalIdError) {
    GetTransactionByExternalIdError["transactionNotFound"] = "TRANSACTION_NOT_FOUND";
    GetTransactionByExternalIdError["bookNotFound"] = "BOOK_NOT_FOUND";
})(GetTransactionByExternalIdError || (exports.GetTransactionByExternalIdError = GetTransactionByExternalIdError = {}));
var ReverseTransactionError;
(function (ReverseTransactionError) {
    ReverseTransactionError["accountNotFound"] = "ACCOUNT_NOT_FOUND";
    ReverseTransactionError["transactionNotFound"] = "TRANSACTION_NOT_FOUND";
    ReverseTransactionError["transactionAlreadyReversed"] = "TRANSACTION_ALREADY_REVERSED";
})(ReverseTransactionError || (exports.ReverseTransactionError = ReverseTransactionError = {}));
